




















































































































































































//@ts-nocheck
//@ts-ignore
import { Component, Vue } from 'vue-property-decorator';


//@ts-ignore
import indicador_desempeno_enlaces from '@/mixins/axios/indicador_desempeno_enlaces'
//@ts-ignore
import dependencias from '@/mixins/axios/general_secretarias'

//@ts-ignore
import departamentos from '@/mixins/axios/general_departamentos'

//@ts-ignore
import indicador_frecuencias from '@/mixins/axios/indicador_frecuencias'

//@ts-ignore
import indicador_clasificaciones from '@/mixins/axios/indicador_clasificaciones'



//@ts-ignore
import TablePPoa from '@/components/tables/tablev1'
//@ts-ignore
import PmdHeader from '@/components/headersSelect/pmd'


//@ts-ignore
import { email, required } from 'vuelidate/lib/validators';
//@ts-ignore
import Notiflix from "notiflix";
//import {Vuetable,VuetablePagination} from 'vuetable-2'


@Component({
  components: {
   /*
    Vuetable,
    VuetablePagination,*/
    
    TablePPoa
  },
  data() {
    return {
        //idmunicipio,nombre, fecha_alta, 
            // tipo, total_empleados, nombre_titular, correo, abreviacion,
  
        columnasd:[
             {
                tag:'id',
                data:'id',
                active:false
            },
            
            {
                tag:'delete',
                data:'delete',
                active:false
            },
            {
                tag:'edit',
                data:'edit',
                active:false
            },
            {
                tag:'clasificacion',
                data:'clasificacion',
                active:true
            },
            {
                tag:'clave',
                data:'clave',
                active:true
            },
             {
                tag:'nombre',
                data:'nombre',
                active:true
            },
             {
                tag:'objetivo_indicador',
                data:'objetivo_indicador',
                active:true
            },
           
             {
                tag:'variables_agregadas',
                data:'variables_agregadas',
                active:true
            },
             {
                tag:'formula',
                data:'formula',
                active:true
            },
             {
                tag:'unidad_medida_resultado',
                data:'unidad_medida_resultado',
                active:true
            },
             {
                tag:'frecuencia',
                data:'frecuencia',
                active:true
            },
             {
                tag:'secretaria',
                data:'secretaria',
                active:true
            },
             {
                tag:'departamento',
                data:'departamento',
                active:true
            },
             {
                tag:'valor_min',
                data:'valor_min',
                active:true
            },
             {
                tag:'valor_max',
                data:'valor_max',
                active:true
            },
             {
                tag:'meta',
                data:'meta',
                active:true
            },
            
             
            
           
        ],

        id:null as any,

      idclasificacion:'' as any,
      clave:'' as any,
      nombre:'' as any,
      objetivo_indicador:'' as any,
      interpretacion:'' as any,
     // idvariables:'' as any,
      variables_agregadas:'' as any,
      formula:'' as any,
      unidad_medida_resultado:'' as any,
      idfrecuencia:'' as any,
      idsecretaria:'' as any,
      iddepartamento:'' as any,
      valor_min:'' as any,
      valor_max:'' as any,
      meta:'' as any,
    
     
     
         
         
              indicador_desempenodata:[] as any,
               departamentos:[] as any,
     dependencias:[] as any,
     indicador_frecuencias:[] as any,
     indicador_clasificaciones:[] as any,
      
    }
  },
     mixins: [indicador_desempeno_enlaces, dependencias,
     departamentos,
     indicador_frecuencias,
     indicador_clasificaciones],
     validations: {
    
           idclasificacion: {
      required,
    },
    
           clave: {
      required,
    },
    
           nombre: {
      required,
    },
    
           objetivo_indicador: {
      required,
    },
    
           interpretacion: {
      required,
    },
    
           variables_agregadas: {
      required,
    },
    
           formula: {
      required,
    },
    
           unidad_medida_resultado: {
      required,
    },
    
           idfrecuencia: {
      required,
    },
    
           idsecretaria: {
      required,
    },
       iddepartamento: {
      required,
    },
          valor_min: {
      required,
    },
          valor_max: {
      required,
    },
          meta: {
      required,
    },
    

   
  },
  methods:{
       onChange(event){
//console.log(event.target.value)
this.getDataDepartamentos(event.target.value);
},
async getDataDepartamentos(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
iddependencia:id,
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_GENERAL_DEPARTAMENTOS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.departamentos=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async getDataSecretarias() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_SECRETARIAS(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.dependencias=response;
this.getDataDepartamentos(response[0].id);
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
   onChangeC(event){
//console.log(event.target.value)
this.getDataClasificacion(event.target.value);

},
      onChangeF(event){
//console.log(event.target.value)

this.getDataFrecuencia(event.target.value);
},
       async getDataClasificacion(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_INDICADOR_CLASIFICACION(data).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_clasificaciones=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},

       async getDataFrecuencia(id) {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio

};

let data= await this.GET_INDICADOR_FRECUENCIA(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_frecuencias=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},
      async eliminar(row){
         
this.$root.$emit('loading', true);
let data= await this.ELIMINAR_INDICADOR_DESEMPENO_ENLACES(row).then(response => {

                    if (response != null) {

 this.indicador_desempenodata=this.indicador_desempenodata.filter(item => item.id !== row.id);
 
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar eliminar paquete, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                });
      },
  /*     select(row){

//alert('pmd seleccionado');
 //this.$store.state.pmd_sel=row;
 this.$store.commit('SETPMD',row);
           //this.secretaria_sel=row;
//this.departamentos=true;
 //this.$store.commit('SETSECRETARIA',row);
   this.$router.push('/mun/general/pmd/ejes')
//this.getDataDepartamentos();

      
     },*/
     confirm(row){

let th=this;
Notiflix.Confirm.Show('Alerta de confirmacion','Desea eliminar este elemento?','Aceptar','Cancelar',function(){ 
    
    th.eliminar(row);
    },function(){ 
      
        
    });



      
     },
      limpiar(){
this.id=null;
 
           
                 this.idclasificacion=0;
                 this.clave=null;
                 this.nombre=null;
                 this.objetivo_indicador=null;
                 this.interpretacion=null;
                 //this.idvariables=0;
                 this.variables_agregadas=null;
                 this.formula=null;
                 this.unidad_medida_resultado=null;
                 this.idfrecuencia=0;
                 this.idsecretaria=0;
                 this.iddepartamento=0;
                 this.valor_min=null;
                 this.valor_max=null;
                 this.meta=null;
     
           
      },
      addRow(){
          this.limpiar();
 $('#ac_modal_indicador_desempeno').modal('show')
      },
seteditar(row){


 this.id=row.id;
 this.idclasificacion=row.idclasificacion;
 this.clave=row.clave;
  this.nombre=row.nombre;
   this.objetivo_indicador=row.objetivo_indicador;
    this.interpretacion=row.interpretacion;
    // this.idvariables=row.idvariables;
      this.variables_agregadas=row.variables_agregadas;
       this.formula=row.formula;
        this.unidad_medida_resultado=row.unidad_medida_resultado;
         this.idfrecuencia=row.idfrecuencia;
          this.idsecretaria=row.idsecretaria;
           this.iddepartamento=row.iddepartamento;
  this.valor_min=row.valor_min;
    this.valor_max=row.valor_max;
      this.meta=row.meta;

            
          
 $('#ac_modal_indicador_desempeno').modal('show')
    

},
     async crear(dat){
let data= await this.CREAR_INDICADOR_DESEMPENO_ENLACES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)

  this.indicador_desempenodata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar editar Indicador Desempeno Enlaces, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });

      },
     async editar(dat){


let data= await this.EDITAR_INDICADOR_DESEMPENO_ENLACES(dat).then(response => {

                    if (response != null) {
                        //this.plantas = response;
console.log(response)
 this.$root.$emit("success", "Indicador de desempeño enlaces modificado exitosamente, refresque la pagina");
  this.indicador_desempenodata=this.indicador_desempenodata.filter(item => item.id !== dat.id);
 this.indicador_desempenodata.push(response)
                    } else {
                        this.$root.$emit("alerta_show", "Ocurrio un error al intentar crear Indicador Desempeno Enlaces, refresque la pagina");

                    }
 this.$root.$emit('loading', false);
                    //loading.close();
                });


      }
     ,
     async GuardarData(){



console.log('id:'+this.id)

let dat={
  id:this.id,
     
     idclasificacion:this.idclasificacion,
            clave:this.clave,
             nombre:this.nombre,
              objetivo_indicador:this.objetivo_indicador,
               interpretacion:this.interpretacion,
               // idvariables:this.idvariables,
                 variables_agregadas:this.variables_agregadas,
                  formula:this.formula,
                   unidad_medida_resultado:this.unidad_medida_resultado,
                    idfrecuencia:this.idfrecuencia,
                     idsecretaria:this.idsecretaria,
                      iddepartamento:this.iddepartamento,
                       valor_min:this.valor_min,
                        valor_max:this.valor_max,
                         meta:this.meta,
                        
            idmunicipio:this.$store.state.user.usuario.id_municipio,

}
console.log(dat)
 this.$root.$emit('loading', true);
 if(this.id==null){
     this.crear(dat);
 }else{
       this.editar(dat);
 }

      },
async getData() {
  
 this.$root.$emit('loading', true);
 console.log('loaddding')

let data2={
idmunicipio:this.$store.state.user.usuario.id_municipio
};

let data= await this.GET_INDICADOR_DESEMPENO_ENLACES(data2).then(response => {

                    if (response != null) {
                        //this.plantas = response;
                        
this.indicador_desempenodata=response;
                    } else {
                        //this.$root.$emit("alerta_show", "Ocurrio un error al intentar cargar las plantas, refresque la pagina");
console.log('ocurrio un error')
                    }
                    this.$root.$emit('loading', false);

                    //loading.close();
                });
},



  },
  mounted(){
      this.getData();
      this.getDataSecretarias();
      this.getDataFrecuencia();
    this.getDataClasificacion();

      //alert('10')
  }
})
export default class Home extends Vue {}

